import { render, staticRenderFns } from "./ModalHeaderV2.vue?vue&type=template&id=3439884f&scoped=true&"
import script from "./ModalHeaderV2.vue?vue&type=script&lang=js&"
export * from "./ModalHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeaderV2.vue?vue&type=style&index=0&id=3439884f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439884f",
  null
  
)

export default component.exports